import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom'
import logoImg from '../assets/logo.svg'
import './Header.css'

export interface NavItem {
  label: string;
  to: string;
  isExternal?: boolean;
}

const navItems: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'COA Lookup', to: '/search' },
  { label: 'Submit Samples', to: '/request' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const renderNavLink = (item: NavItem) => {
    if (item.isExternal) {
      return (
        <a
          href={item.to}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link"
          onClick={closeMenu}
        >
          {item.label}
        </a>
      );
    }
    return (
      <NavLink
        to={item.to}
        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        onClick={closeMenu}
      >
        {item.label}
      </NavLink>
    );
  };

  return (
    <header className="header" role="banner">
      <div className="header-content">
        <Link to="/" className="header-logo" aria-label="Hilton Analytica Home">
          <img src={logoImg} alt="Hilton Analytica" className="header-logo-icon" />
          <span className="header-company-name">Hilton Analytica</span>
        </Link>
        <button 
          className="header-menu-toggle" 
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>
        <nav 
          className={`header-nav ${isMenuOpen ? 'open' : ''}`} 
          role="navigation" 
          aria-label="Main navigation"
        >
          {navItems.map((item) => (
            <span key={item.to}>{renderNavLink(item)}</span>
          ))}
        </nav>
      </div>
    </header>
  )
}

export default Header